import { FC, useState } from 'react'
import { ApplicationFrame } from '../../components/ApplicationFrame'
import uberLogo from '../../assets/uber-direct-delivery/logo.png'
import {
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
} from '@mui/material'
import { useSearchParams } from 'react-router-dom/dist'
import {
  useClientApiCall,
  useClientApiMutation,
} from '../../hooks/useClientApiCall'

/**
 * Uber Eats Application
 */
export const UberDirectDelivery: FC = () => {
  const [params] = useSearchParams()
  const session = params.get('session')!
  const connection = useClientApiCall<any>(session, 'connection')
  const connect = useClientApiMutation(session, 'connect')
  const [customerId, setCustomerId] = useState<string | undefined>(undefined)

  /**
   * Extract existing customer id from the connection
   */
  const existingCustomerId = connection.data?.uberDirectCustomerId

  const onConnect = () => {
    connect.mutate({ customerId })
  }

  /**
   *
   */
  return (
    <ApplicationFrame heroImage={uberLogo} backgroundColor="#0092ff">
      {/* Centralised Title with padding */}
      <Typography variant="h4" align="center" sx={{ p: 2 }}>
        Uber Direct
      </Typography>

      {/* A form element to collect the customer id that should be used for this integration */}
      <Box pb={2}>
        <Grid container spacing={3} p={2}>
          <Grid item sm={12}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="Customer ID"
                fullWidth
                defaultValue={existingCustomerId}
                onChange={(event) => setCustomerId(event.target.value)}
                value={customerId}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid item sm={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={onConnect}
            disabled={!customerId || connect.isLoading}
          >
            Save
          </Button>
        </Grid>
      </Box>
    </ApplicationFrame>
  )
}
